import React, { useEffect, useState } from "react";
import TableToolbar from "../tableToolBar";

interface StatusTab {
  label: string;
  value: string;
}

interface TableControlsProps {
  status: string | undefined;
  setStatus: (status: string | undefined) => void;
  search: string;
  setSearch: (search: string) => void;
  openFilters: boolean;
  setOpenFilters: (open: boolean) => void;
  statusTabs: StatusTab[];
  showFilter?: boolean;
  showSearch?: boolean;
  debounceDelay?: number; // Optional: customize delay per usage
}

const TableControls: React.FC<TableControlsProps> = ({
  status,
  setStatus,
  search,
  setSearch,
  openFilters,
  setOpenFilters,
  statusTabs,
  showFilter = true,
  showSearch = true,
  debounceDelay = 500, // Default 500ms delay
}) => {
  const [internalSearch, setInternalSearch] = useState(search);

  // Sync internal search with external prop on mount or external changes
  useEffect(() => {
    setInternalSearch(search);
  }, [search]);

  // Debounce: update parent's search state after delay
  useEffect(() => {
    const timer = setTimeout(() => {
      setSearch(internalSearch);
    }, debounceDelay);

    return () => {
      clearTimeout(timer);
    };
  }, [internalSearch, debounceDelay, setSearch]);

  return (
    <div className="pt-4">
      <TableToolbar
        statusTabs={statusTabs}
        currentStatus={status}
        onStatusChange={setStatus}
        searchValue={internalSearch}
        onSearchChange={setInternalSearch} // Update internal state immediately
        onFilterClick={() => setOpenFilters(!openFilters)}
        showFilter={showFilter}
        showSearch={showSearch}
      />
    </div>
  );
};

export default TableControls;
